import { AppRoutingService } from '@core/app-routing.service';
import { IClassroomContext } from '@models/classroom-context';
import { NavigationMenuItem } from '@models/navigation-menu-item';
import { Capabilities } from '@shared/enums/capabilities';
import { CapabilityType } from '@shared/enums/capability-type';
import { Helpers } from '@shared/helpers';
import { BehaviorSubject } from 'rxjs';

export enum ClassesSubNavMenuId {
  Overview = 'class-subnav-manage-class-overview',
  Quests= 'class-subnav-quests',
  ClassSettings= 'class-subnav-manage-class-settings',
  ParentPortal = 'class-subnav-manage-parent-portal'
}

export function buildClassesSubnav(
  appRoutingService: AppRoutingService,
  subNavMenuItems: BehaviorSubject<NavigationMenuItem[]>,
  classroomContext: IClassroomContext,
): void {
  const questCapableLicenses = classroomContext?.licenses
    .filter(license => Helpers.hasProductCapability(license, Capabilities.QuestDashboard, CapabilityType.Classroom));
  const hasStudents = !!classroomContext?.students?.length;
  const hasLicenses = !!classroomContext?.licenses?.length;
  const hasQuestCapableLicenses = !!questCapableLicenses?.length;
  const newMenus: NavigationMenuItem[] = [];
  const classroomId = classroomContext.classroom?.classroomId;
  newMenus.push(
    {
      id: ClassesSubNavMenuId.Overview,
      weight: 0,
      route: appRoutingService.getTeachersClassroomRoute(classroomId).toString(),
      label: 'Overview'
    },
    {
      id: ClassesSubNavMenuId.Quests,
      weight: 1,
      route: appRoutingService.getTeachersClassroomQuestsRoute(classroomId).toString(),
      label: 'Quests',
      disabled: !hasStudents || !hasLicenses || !hasQuestCapableLicenses,
      tooltip: (!hasStudents || !hasLicenses || !hasQuestCapableLicenses)
        ? 'You must add students and class licenses to access Quests' : '',
    },
    {
      id: ClassesSubNavMenuId.ClassSettings,
      weight: 2,
      route: appRoutingService.getTeachersClassroomSettingsRoute(classroomId).toString(),
      label: 'Class Settings',
      disabled: !hasLicenses,
      tooltip: !hasLicenses ? `You must add class licenses to access Class Settings` : '',
    },
    {
      id: ClassesSubNavMenuId.ParentPortal,
      weight: 3,
      route: appRoutingService.getTeachersClassroomParentPortalRoute(classroomId).toString(),
      label: 'Manage Parent Portal',
      disabled: !hasStudents || !hasLicenses,
      tooltip: (!hasStudents || !hasLicenses)
        ? 'You must add students and class licenses to be able to post a parent portal message.' : '',
    }
  );

  subNavMenuItems.next(newMenus);
}

